import React, { Fragment } from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { EngagementMenuItem } from './EngagementMenuItem';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';

export interface MyEngagementsMenuItemProps {
    engagements?: any[];
}

export const MyEngagementsMenuItem = (props: MyEngagementsMenuItemProps) => {
    const engagements = props.engagements ?? [];
    const items = engagements.filter(
        (engagement) => engagement.party === TimelineParty.Seller
    );

    return (
        <Fragment>
            <LeftMenuItem
                icon="pe-7s-plugin"
                label="My Engagements"
                className="app-sidebar__heading vertical-nav-menu custom "
                marginLeft={-10}
                stateIcon="pe-7s-plugin"
                trackingAction="My Engagements"
            />
            {items.map((engagement, index) => (
                <EngagementMenuItem key={index} engagement={engagement} />
            ))}
        </Fragment>
    );
};
